import SequenceConfig from "./SequenceConfig";
import BaseContent from "../utils/BaseContent";
import * as _ from "lodash";
import { Subject, Observable } from "rxjs";

export default abstract class BaseSequence extends BaseContent {
  protected state: any = {};
  protected sequencerEventSubject: Subject<any> = new Subject<any>();
  protected subscriptions: any[] = [];
  constructor(public config: SequenceConfig) {
    super();
    this.subscribeToSequencerEvent();
  }
  public abstract async start(): Promise<{}>;
  public abstract setItemResult(result: any, itemIndex?: number): void;
  public abstract getAllResult(): any;
  public abstract getNextQuestion(): any;
  public abstract getSequencerProps(): any;
  public getState(): any {
    return this.state;
  }
  public setState(partialState: any): void {
    _.assign(this.state, partialState);
  }
  protected subscribeToSequencerEvent(): void { }
  public get observable(): Observable<any> {
    return this.sequencerEventSubject.asObservable();
  }

  public cleanup(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
  public get subject(): Subject<any> {
    return this.sequencerEventSubject;
  }
}
